import { Roles } from "@shared/Roles";
import { HyperBackendMethod } from "@shared/backend/hyper-backend-method";
import { WEME_ORGANIZATION_ID } from "@shared/helpers/constants";
import { Controller, repo } from "remult";
import { OrganizationManager } from "../organization-manager";
import { Organization } from "./entity";

@Controller("organization-methods")
export class OrganizationMethods {
  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: true,
    overrideSecurity: true,
  })
  static async getName(orgId: string) {
    const org = await repo(Organization).findId(orgId);
    return org?.name;
  }

  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: true,
    overrideSecurity: true,
  })
  static async getNameAndImageId(orgId: string) {
    const org = await repo(Organization).findId(orgId);
    return { name: org?.name, imageId: org?.organizationImageId };
  }

  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: true,
    overrideSecurity: true,
  })
  static async doesExist(organizationId: string) {
    const organization = await repo(Organization).findId(organizationId);
    return !!organization;
  }

  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: Roles.AdminsAndManager,
    overrideSecurity: true,
  })
  static async getManagers(phoneNumber: string) {
    const managers = await repo(OrganizationManager).find({
      where: { phoneNumber },
      include: { organization: true },
    });
    return managers;
  }

  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: true,
    overrideSecurity: true,
  })
  static async getWemeOrganization() {
    /* MAKE SURE NO 'private' DATA IS RETURNED!!!! */
    /* THIS METHOD IS `allowed: true` and should remain this way */
    return (await repo(Organization).findId(WEME_ORGANIZATION_ID, {
      include: {
        organizationPositions: {
          include: {
            subCategories: true,
          },
        },
        categories: {
          include: {
            subCategories: true,
          },
          orderBy: {
            createdAt: "asc",
          },
        },
        populations: {
          orderBy: {
            createdAt: "asc",
          },
        },
      },
    }))!;
  }

  @HyperBackendMethod({
    apiPrefix: "organization-methods",
    allowed: true,
    overrideSecurity: true,
  })
  static async getOrganization(organizationId: string) {
    const organization = await repo(Organization).findId(organizationId);
    return {
      name: organization?.name,
      id: organization?.id,
      organizationImageId: organization?.organizationImageId,
    };
  }
}
